import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductinformationComponent } from './productinformation.component';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'app/shared/loading/loading.module';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
// import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { ApplicationPipesModule } from '@shared/helper/pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { MatSelectModule } from '@angular/material/select';


const routes: Routes = [{ path: '', component: ProductinformationComponent }];
@NgModule({
  declarations: [ProductinformationComponent],
  imports: [
    // RouterModule.forChild(routes),
    CommonModule,
    FormsModule, ReactiveFormsModule,
    LoadingModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatListModule,
    MatSelectModule,
    MatDialogModule,
    ApplicationPipesModule,
    NgbModule,
    // NgxMaskModule.forRoot(),
  ],
  entryComponents: [ProductinformationComponent],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    RouterModule,
    ProductinformationComponent
  ]
})
export class ProductinformationModule { }
